import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

// Domain configuration for production with port 8002 support
const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8002'
    : 'https://likaiev.com';

const Enquiry = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        product: '',
        message: ''
    });

    const [products, setProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/products/`);
                setProducts(Array.isArray(response.data) ? response.data : response.data.results || []);
            } catch (error) {
                console.log("Error fetching products:", error);
            } finally {
                setLoadingProducts(false);
            }
        };
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${BASE_URL}/api/enquiry/`, formData);
            alert("Enquiry submitted successfully!");
            setFormData({ name: '', email: '', phone: '', product: '', message: '' });
        } catch (error) {
            console.log("Error saving enquiry:", error);
            alert("Failed to submit. Please check your details.");
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen">
            <div
                className="relative h-[350px] w-full flex items-center justify-center mb-16 overflow-hidden bg-cover bg-center"
                style={{
                    backgroundImage: "url('/banner1.jpg')"
                }}
            >
                <div className="absolute inset-0 bg-blue-900/70"></div>
                <h1 className="relative z-10 text-5xl md:text-6xl font-bold text-white tracking-widest text-center px-4">
                    ENQUIRY FORM
                </h1>
            </div>

            <div className="container mx-auto px-6 pb-20">
                <div className="max-w-3xl mx-auto bg-white p-10 rounded-2xl shadow-2xl border border-gray-100">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid md:grid-cols-2 gap-6">
                            <input name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-900 outline-none" required />
                            <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Email Address" className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-900 outline-none" required />
                        </div>

                        <div className="grid md:grid-cols-2 gap-6">
                            <input name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-900 outline-none" required />

                            {/* Select Product Dropdown */}
                            <select name="product" value={formData.product} onChange={handleChange} className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-900 outline-none" required>
                                <option value="">
                                    {loadingProducts ? "Loading products..." : "Select Product Interest"}
                                </option>
                                {Array.isArray(products) && products.map((p) => (
                                    <option key={p.id} value={p.id}>{p.title}</option>
                                ))}
                            </select>
                        </div>

                        <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message" rows="5" className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-900 outline-none"></textarea>

                        <button type="submit" className="w-full bg-blue-900 text-white py-4 rounded-lg font-bold hover:bg-orange-600 transition shadow-lg">
                            SUBMIT YOUR ENQUIRY
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Enquiry;